import React from 'react';
import { TextField, MenuItem, CircularProgress } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketAssignment } from '../../../../state';
import { useGetTeamsQuery } from '../../../../../../services/TeamService';

const AssignedTeamEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  
  // Fetch teams for dropdown
  const { 
    data: teams, 
    isLoading: teamsLoading,
    error: teamsError 
  } = useGetTeamsQuery({ status: undefined });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateTicketAssignment({ assignedTeam: event.target.value }));
  };

  if (teamsLoading) {
    return (
      <TextField
        label="Assigned Team"
        size="small"
        fullWidth
        disabled
        value=""
        InputProps={{
          endAdornment: <CircularProgress size={20} />
        }}
      />
    );
  }

  if (teamsError) {
    return (
      <TextField
        label="Assigned Team"
        size="small"
        fullWidth
        error
        helperText="Error loading teams"
        value={currentTicket?.assignment.assignedTeam || ''}
        onChange={handleChange}
        placeholder="Enter team name"
      />
    );
  }

  return (
    <TextField
      select
      label="Assigned Team"
      size="small"
      fullWidth
      value={currentTicket?.assignment.assignedTeam || ''}
      onChange={handleChange}
    >
      <MenuItem value="">
        <em>None</em>
      </MenuItem>
      {teams?.map((team) => (
        <MenuItem key={team.id} value={team.id}>
          {team.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default AssignedTeamEdit;
